import { useQuery } from "@tanstack/react-query";

import { getFeatBitSegments } from "services";

import { GET_FEATBIT_SEGMENTS } from "consts";

import { FeatBitEnvironmentWithSegments } from "models";

// Segments are created and deleted in FeatBit, so always refetch instead of trusting the cache.
export const useGetFeatBitSegments = () =>
  useQuery<FeatBitEnvironmentWithSegments[]>({
    queryKey: [GET_FEATBIT_SEGMENTS],
    queryFn: getFeatBitSegments,
    refetchOnMount: "always",
    // A FeatBit outage or missing config does not recover on retry.
    retry: false,
  });
